export default __webpack_public_path__ + "static/media/KTrussDiaImg.c64df5f6.png";